export default {
    state: {
        all: [],
        filtered: [],
        selectedUnitId: null
    },
    getters: {
        selectedUnit: (state) => {
            return _.find(state.all, ['id', state.selectedUnitId]);
        }
    }
};